import { render, staticRenderFns } from "./requestShareIng.vue?vue&type=template&id=9f0249ba"
import script from "./requestShareIng.vue?vue&type=script&lang=js"
export * from "./requestShareIng.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports